import { Collapse, Text } from 'components';
import React from 'react';

const Instructions: React.FC = () => (
    <Collapse>
      <Collapse.Panel header="Instructions" key="1">
        <Text>
          1. Assume the user you want to SSO as. You can also login as the user,
          but you won&apos;t have access to this page if the user is not from
          the brokerbay org. You can also simulate a first time SSO by using the{' '}
          <kbd>Unclaim User</kbd> button to unclaim the user by id (default id
          is the assumed user). If testing with an unclaimed user avoid having
          additional tabs of the web app open (use SSO button instead of link)
          as they will auto-refresh and may claim the user automatically. Also
          avoid using a user that cannot be logged into normally such as the
          auto-genereated brokerbay admin account.
          <br />
          <br />
          2. Choose the SSO flow you want to follow and input any parameters, if
          needed. For testing the configure listing flow on an existing listing,
          only the mls number and mlsType of the listing needs to be entered.
          For testing the listing shell flow of a non-existent listing,
          You&apos;ll need to at least provide parameters for the <b>
            oid
          </b>, <b>mlsNumber</b> (see <kbd>RETS_LISTING</kbd> config) and the{' '}
          <b>mls_agent_id</b> (see <kbd>LISTING</kbd> config). To get the
          correct parameter names, you can reference the cartographer configs
          for the mls and look for the corresponding Rets Key. For example, the
          corresponding Rets Key for the BB key <b>oid</b> might be listed as{' '}
          <b>ListOfficeMlsId</b> according to the <kbd>RETS_LISTING</kbd> config
          in Cartographer. Note that the <b>mls_agent_id</b> does not need to
          point to a real agent mls id for the listing to be created but you
          will need to make sure the user you are assumed as will have
          permission to the created listing.
          <br />
          <br />
          3. Click the <kbd>SSO</kbd> button. You will follow the SSO flow you
          chose for the assumed user. The SSO provider in this scenario is the
          web app itself.
        </Text>
      </Collapse.Panel>
    </Collapse>
  );

export default Instructions;
